import type { Tower } from '../../../data/types';

/** Grey pointed caps visible in the painting, rather than red domestic roof tiles. */
export function towerHasSlateRoof(tower: Pick<Tower, 'id'>): boolean {
  return [
    'tower-schreierstoren',
    'tower-jan-roodenpoort',
    'tower-heilig-kruistoren',
  ].includes(tower.id);
}

export const FORTIFICATION_ROOF = {
  coveredWalk: {
    rise: 2,
    overhang: 0.5,
  },
  tower: {
    cone: { riseRatio: 1.2 },
    spire: { riseRatio: 3.0, baseRatio: 0.9 },
    hip: { riseRatio: 0.8 },
    flat: { parapetHeight: 1.0, parapetThickness: 0.5 },
  },
  gate: {
    hipRiseRatio: 0.3,
    passageHeight: 4.5,
    maxPassageWidth: 4,
    passageWidthRatio: 0.4,
    flankingTower: {
      radiusRatio: 0.22,
      heightRatio: 1.2,
      segments: 16,
    },
    waterTower: {
      radiusRatio: 0.25,
      segments: 16,
    },
    waterArch: {
      height: 5.5,
      depth: 2,
      thickness: 2,
    },
  },
} as const;
